<div class="w-full font-extrabold  mx-auto min-h-[500px] mb-8 md:mb-12 flex items-start justify-start flex-col">
    <div *ngFor="let quiz of data" class="w-full">
        <app-polar [user]="user" *ngIf="quiz.chart_type=='SPIDER'" [spiderChart]="quiz" class="w-full"></app-polar>
        <app-pie [user]="user" *ngIf="quiz.chart_type=='PIE'" [pieChart]="quiz" class="w-full"></app-pie>
        <app-horizontal-bar [user]="user" *ngIf="quiz.chart_type=='HORIZONTAL_BAR' && quiz.output_type!='NUMBER'" [horizontalChart]="quiz" class="w-full"></app-horizontal-bar>
    </div>
</div>